import { ErrorText, FormTextarea, Label, Wrapper } from './Textarea.styled';
import { FC, TextareaHTMLAttributes } from 'react';

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label?: string;
  error?: Array<string>;
}

export const Textarea: FC<TextareaProps> = ({
  name,
  label = '',
  error = [],
  ...rest
}) => {
  return (
    <Wrapper>
      {label.length ? <Label htmlFor={name}>{label}</Label> : null}
      <FormTextarea id={name} {...rest} />
      {error.length ? <ErrorText>{error[0]}</ErrorText> : null}
    </Wrapper>
  );
};
